import { render, staticRenderFns } from "./OfficeDetail.vue?vue&type=template&id=28d52b29&scoped=true&"
import script from "./OfficeDetail.vue?vue&type=script&lang=js&"
export * from "./OfficeDetail.vue?vue&type=script&lang=js&"
import style0 from "./OfficeDetail.vue?vue&type=style&index=0&id=28d52b29&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d52b29",
  null
  
)

export default component.exports